import React, { Fragment } from 'react';
import MetaTags from 'react-meta-tags';

import Header from '../blocks/header/Header';
import Footer from '../blocks/footer/Footer';
import Markdown from '../content/Markdown';
import content from '../content/impressum.json';

class Imprint extends React.Component {

  constructor(props) {
    super(props);
    document.body.classList.add( 'home' );
    document.body.classList.add( 'header-absolute-true' );
  }

  render() {
    return (
      <Fragment>
        <MetaTags>
          <meta charSet="UTF-8" />
          <title>{content.title} | Secare Friseursalon</title>
          <meta name="robots" content="noindex, follow" />
        </MetaTags>

        <Header logoColor="light" />

        <main id="main" className="site-main content-no-spacing">
          <div className="content">
            <div id="imprint" className="clearfix">
              <h1>{content.title}</h1>
              <Markdown>{content.body}</Markdown>
            </div>
          </div>
        </main>

        <Footer />
      </Fragment>
    );
  }
};

export default Imprint;
